import classNames from 'classnames';
import { HeartIcon } from 'src/components/svg/HeartIcon';

interface AddFavoriteButtonProps {
  handleThrottleAddFavorite: () => void;
  isFavorite?: boolean;
  heartIconSize?: string;
}

export const AddFavoriteButton = ({
  handleThrottleAddFavorite,
  isFavorite,
  heartIconSize
}: AddFavoriteButtonProps) => {
  return (
    <button
      onClick={handleThrottleAddFavorite}
      className="absolute right-2.5 z-[4] top-2.5  cursor-pointer rounded-md border bg-gc_icon_bg border-gc_icon_border bg-opacity-100">
      <HeartIcon
        isFavorite={isFavorite}
        fill="white"
        className={classNames(heartIconSize ? heartIconSize : 'h-4 w-4')}
      />
    </button>
  );
};
